"use client";

import Image from "next/image";
import Link from "next/link";
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { useEffect, useState } from "react";

const footerWidget = [
  {
    id: 1,
    title: "Quick Links",
    footer__links: [
      { list: "Privacy Policy", path: "/privacy-policy" },
      { list: "Terms & Condition", path: "/terms-and-conditions" },
      { list: "Returns & Refunds", path: "/returns-and-refunds" },
    ],
  },
  {
    id: 2,
    title: "Customer Services",
    footer__links: [
      { list: "Help & Contact Us", path: "/contact" },
      { list: "Online Store", path: "/shop" },
      { list: "About Us", path: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#ffffff",
        color: "#333",
        paddingTop: "80px",
        marginTop: "60px",
        borderTop: "1px solid #e5e5e5",
        position: "relative",
      }}
    >
      {/* Main Footer Container */}
      <div
        style={{
          maxWidth: "1300px",
          margin: "0 auto",
          padding: "0 24px",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "40px",
            marginBottom: "60px",
          }}
        >
          {/* Logo & Description */}
          <div
            style={{
              borderRadius: "16px",
              padding: "32px",
              background: "#fafafa",
              border: "1px solid #e5e5e5",
            }}
          >
            {/* Logo */}
            <div style={{ marginBottom: "24px", display: "flex", alignItems: "center", gap: "12px" }}>
              <img
                src="/logo/logo.png"
                alt="iMall"
                style={{
                  width: "50px",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: "900",
                  letterSpacing: "1px",
                  fontFamily: "'Poppins', sans-serif",
                  background: "linear-gradient(135deg, #FF6B35 0%, #f7931e 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  margin: 0,
                }}
              >
                iMall
              </h2>
            </div>

            <p
              style={{
                fontSize: "14px",
                color: "#666",
                lineHeight: 1.7,
                marginBottom: "24px",
              }}
            >
              Your trusted online shopping destination. Bringing thousands of products from top brands to your doorstep with quality and convenience.
            </p>

            {/* Social Links */}
            <div style={{ display: "flex", gap: "12px" }}>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #1877f2 0%, #0c63d4 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(24, 119, 242, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(24, 119, 242, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(24, 119, 242, 0.3)";
                }}
              >
                <Facebook size={20} color="#fff" />
              </a>

              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #E1306C 0%, #C13584 50%, #833AB4 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(225, 48, 108, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(225, 48, 108, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(225, 48, 108, 0.3)";
                }}
              >
                <Instagram size={20} color="#fff" />
              </a>

              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #1DA1F2 0%, #0c85d0 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(29, 161, 242, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(29, 161, 242, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(29, 161, 242, 0.3)";
                }}
              >
                <Twitter size={20} color="#fff" />
              </a>

              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #FF0000 0%, #cc0000 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(255, 0, 0, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(255, 0, 0, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 0, 0, 0.3)";
                }}
              >
                <Youtube size={20} color="#fff" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div
            style={{
              borderRadius: "16px",
              padding: "32px",
              background: "#fafafa",
              border: "1px solid #e5e5e5",
            }}
          >
            <h4
              style={{
                color: "#1a1a1a",
                fontSize: "18px",
                fontWeight: 800,
                marginBottom: "24px",
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              Contact Us
            </h4>

            <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
              <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                <MapPin size={20} style={{ color: "#FF6B35", marginTop: "2px" }} />
                <p style={{ margin: 0, color: "#666", fontSize: "14px", lineHeight: "1.6" }}>
                 17/6, Eskaton Garden Road, Magbazar, Dhaka.
                </p>
              </div>

              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <Phone size={20} style={{ color: "#FF6B35" }} />
                <a 
                  href="tel:+8801748399860" 
                  style={{ 
                    color: "#FF6B35", 
                    fontWeight: 600, 
                    textDecoration: "none",
                    fontSize: "14px"
                  }}
                >
                  +88-01315994499
                </a>
              </div>

              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <Mail size={20} style={{ color: "#FF6B35" }} />
                <a
                  href="mailto:support@imall.com"
                  style={{ 
                    color: "#FF6B35", 
                    fontWeight: 600,
                    textDecoration: "none",
                    fontSize: "14px"
                  }}
                >
                  imall.com.bd@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Footer Widgets */}
          {footerWidget.map((item) => (
            <div
              key={item.id}
              style={{
                borderRadius: "16px",
                padding: "32px",
                background: "#fafafa",
                border: "1px solid #e5e5e5",
              }}
            >
              <h4 
                style={{ 
                  fontSize: "18px", 
                  fontWeight: 800, 
                  marginBottom: "24px",
                  color: "#1a1a1a",
                  fontFamily: "'Poppins', sans-serif",
                }}
              > 
                {item.title}
              </h4>

              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {item.footer__links.map((link, i) => (
                  <li key={i} style={{ marginBottom: "12px" }}>
                    <Link
                      href={link.path}
                      style={{
                        color: "#666",
                        textDecoration: "none",
                        fontSize: "14px",
                        transition: "all 0.3s ease",
                        display: "inline-block",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#FF6B35";
                        e.currentTarget.style.marginLeft = "4px";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = "#666";
                        e.currentTarget.style.marginLeft = "0px";
                      }}
                    >
                      → {link.list}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Footer Bottom */}
        <div
          style={{
            borderTop: "1px solid #e5e5e5",
            padding: "24px 0",
            textAlign: "center",
            color: "#666",
            fontSize: "14px",
          }}
        >
          © 2026 iMall — All Rights Reserved
        </div>
      </div>
    </footer>
  );
}